import * as React from 'react';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mate... Remove this comment to see the full error message
import Dialog from 'material-ui/Dialog';
import PropTypes from 'prop-types';

import Button from 'bundles/internal-ui/components/buttons/Button';
import Icon from 'bundles/internal-ui/components/icon/Icon';

import 'css!./__styles__/Modal';

/**
 * @deprecated: This component relies on an outdated version of material-ui.
 * A known bug is that context is not passed down to children.
 * Please do not use this component and use the new CDS Dialog component instead.
 */
class Modal extends React.LegacyComponentWithChildren {
  static propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        style: PropTypes.string,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
      })
    ),
    children: PropTypes.element,
    showCloseIcon: PropTypes.bool,
    scrollable: PropTypes.bool,
    contentStyle: PropTypes.object,
    cardContentStyle: PropTypes.object,
  };

  static defaultProps = {
    actions: [],
    open: false,
    showCloseIcon: false,
    scrollable: false,
    contentStyle: {},
    cardContentStyle: {},
  };

  /* kuan: fixes this issue https://github.com/callemall/material-ui/issues/1676 */
  componentDidUpdate() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  renderActions() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'actions' does not exist on type 'Readonl... Remove this comment to see the full error message
    return this.props.actions.map((action) => {
      return (
        <Button
          text={action.text}
          btnStyle={action.style}
          onClick={action.onClick}
          disabled={action.disabled}
          key={action.text}
        />
      );
    });
  }

  render() {
    return (
      <Dialog
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'open' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        open={this.props.open}
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'onRequestClose' does not exist on type '... Remove this comment to see the full error message
        onRequestClose={this.props.onRequestClose}
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'scrollable' does not exist on type 'Read... Remove this comment to see the full error message
        autoScrollBodyContent={this.props.scrollable}
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'contentStyle' does not exist on type 'Re... Remove this comment to see the full error message
        contentStyle={this.props.contentStyle}
      >
        <div className="card-header alert alert-info">
          <span className="card-title">
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'title' does not exist on type 'Readonly<... Remove this comment to see the full error message */}
            {this.props.title}
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'showCloseIcon' does not exist on type 'R... Remove this comment to see the full error message */}
            {this.props.showCloseIcon && (
              <div
                className="btn btn-round btn-link"
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'onRequestClose' does not exist on type '... Remove this comment to see the full error message
                onClick={this.props.onRequestClose}
                role="button"
                style={{ float: 'right' }}
              >
                <Icon name="close" />
              </div>
            )}
          </span>
        </div>

        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'cardContentStyle' does not exist on type... Remove this comment to see the full error message */}
        <div className="card-content" style={this.props.cardContentStyle}>
          {this.props.children}
        </div>

        <div className="card-action clearfix">
          <div className="pull-right">{this.renderActions()}</div>
        </div>
      </Dialog>
    );
  }
}

export default Modal;
